import React from 'react';

const ReturnFlow = () => (
  <div className="card p-3 mt-3">
    <h5>Retours</h5>
    <p className="text-muted mb-0">
      Le flux de retour nécessite un endpoint de consultation de commande (non présent dans la
      spécification fournie). Cette section est prête à recevoir les lignes de retour dès que
      l’API de consultation sera disponible.
    </p>
  </div>
);

export default ReturnFlow;
